import React from 'react';
import { IDictionaryEntry } from '../Interfaces/IDictionaryEntry';
import { Grid } from '@mui/material';
import { CustomeTextField } from '../generic/CustomeTextField';

interface IProps {
  editDictEntry: IDictionaryEntry;
  setEditDictEntry: Function;
  enableInstantSave: boolean;
}

export const DictionaryEntryEdit: React.FC<IProps> = ({
  editDictEntry,
  setEditDictEntry,
}) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomeTextField
            attr='DictionaryEntry'
            label='Variable'
            object={editDictEntry}
            setObject={setEditDictEntry}
            type='string'
          />
        </Grid>
        <Grid item xs={12}>
          <CustomeTextField
            attr='Description'
            label='Beschreibung'
            object={editDictEntry}
            setObject={setEditDictEntry}
            type='string'
            rows={3}
          />
        </Grid>
      </Grid>
    </>
  );
};
